import React, { useState, useEffect } from 'react';
import HabitForm from '../components/HabitForm';
import HabitList from '../components/HabitList';

const Home = () => {
  const [habits, setHabits] = useState([
    { id: 1, name: "Drink Water", completedToday: false, streak: 0, lastCompletedDate: null },
    { id: 2, name: "Read 10 pages", completedToday: false, streak: 0, lastCompletedDate: null }
  ]);

  // Load habits from localStorage on component mount
  useEffect(() => {
    const savedHabits = localStorage.getItem('habits');
    if (savedHabits) {
      const parsedHabits = JSON.parse(savedHabits);
      // Reset completedToday if lastCompletedDate is not today
      const today = new Date().toDateString();
      const updatedHabits = parsedHabits.map(habit => ({
        ...habit,
        completedToday: habit.lastCompletedDate === today ? habit.completedToday : false
      }));
      setHabits(updatedHabits);
    }
  }, []);

  // Save habits to localStorage whenever habits change
  useEffect(() => {
    localStorage.setItem('habits', JSON.stringify(habits));
  }, [habits]);

  // Update completion history when habits change
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    const completedToday = habits.filter(habit => habit.completedToday).length;
    
    // Load existing history
    const existingHistory = localStorage.getItem('completionHistory');
    let history = existingHistory ? JSON.parse(existingHistory) : [];
    
    // Update today's entry
    const todayIndex = history.findIndex(h => h.date === today);
    if (todayIndex >= 0) {
      history[todayIndex].completedCount = completedToday;
    } else {
      history.push({ date: today, completedCount: completedToday });
    }
    
    // Keep only last 30 days
    history = history.slice(-30);
    
    localStorage.setItem('completionHistory', JSON.stringify(history));
  }, [habits]);

  const addHabit = (habitName) => {
    const newHabit = {
      id: Date.now(),
      name: habitName,
      completedToday: false,
      streak: 0,
      lastCompletedDate: null
    };
    setHabits(prevHabits => [...prevHabits, newHabit]);
  };

  const toggleHabitDone = (id) => {
    setHabits(prevHabits => 
      prevHabits.map(habit => {
        if (habit.id === id) {
          const today = new Date().toDateString();
          const yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000).toDateString();
          
          if (!habit.completedToday) {
            // Mark as done
            let newStreak = habit.streak;
            if (habit.lastCompletedDate === yesterday) {
              newStreak = habit.streak + 1;
            } else if (habit.lastCompletedDate !== today) {
              newStreak = 1;
            }
            
            return {
              ...habit,
              completedToday: true,
              streak: newStreak,
              lastCompletedDate: today
            };
          } else {
            // Toggle off (optional - you can remove this if you don't want to allow unmarking)
            return {
              ...habit,
              completedToday: false
            };
          }
        }
        return habit;
      })
    );
  };

  const deleteHabit = (id) => {
    setHabits(prevHabits => prevHabits.filter(habit => habit.id !== id));
  };

  return (
    <div className="max-w-4xl mx-auto p-4">
      <div className="text-center mb-8">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
          Start building better habits today
        </h2>
        <p className="text-gray-600 text-lg font-medium">
          Track your daily habits and build momentum with our streak counter.
        </p>
      </div>
      
      <HabitForm onAddHabit={addHabit} />
      <HabitList habits={habits} onToggle={toggleHabitDone} onDelete={deleteHabit} />
    </div>
  );
};

export default Home;
